import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectDogTreatReward } from "../../selectors/selectDoghouseInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { componentFromType } from "../generic/componentFromType";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { actionGrantRewardsCollect } from "../grant-rewards/actionGrantRewards";
import { actionDoghouseGiveRequest } from "./actionDoghouse";
import { DoghouseFreeTreatsGivenFooter } from "./DoghouseFreeTreatsGivenFooter";
export var _DialogCollectRewardsDogTreat = function (props) {
    var onCollect = props.onCollect, onCollectAndGive = props.onCollectAndGive, reward = props.reward;
    var footerComponent = componentFromType(DoghouseFreeTreatsGivenFooter);
    var rewardIcon = getResourceIcon(reward);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.yourReward, onClose: onCollect, footerRenderer: footerComponent, className: IdStyles.ModalBackgroundBuyGold },
        React.createElement("div", { className: "reward-details-container" },
            React.createElement("div", { className: "" + IdStyles.DogGraphicRewardContainer }),
            React.createElement("div", { className: IdStyles.DogTreatRewardWonContainer + " rewards-won-container" },
                React.createElement("div", { className: "reward" },
                    React.createElement(Icon, { icon: rewardIcon, styleId: IdStyles.IconLarge }),
                    React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: reward.amount })))),
        React.createElement("div", { className: "collect-rewards-buttons-container " + IdStyles.TextAlignCenter },
            React.createElement(ButtonPrimary, { onClick: onCollectAndGive },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collectAndAgain })),
            React.createElement(ButtonPrimary, { onClick: onCollect },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })))));
};
var mapState = function (state) { return selectDogTreatReward(state); };
var mapDispatch = function (dispatch) { return ({
    onCollect: function () { return dispatch(actionGrantRewardsCollect()); },
    onCollectAndGive: function () {
        dispatch(actionGrantRewardsCollect());
        dispatch(actionDoghouseGiveRequest(true));
    },
}); };
export var DialogCollectRewardsDogTreat = connect(mapState, mapDispatch)(_DialogCollectRewardsDogTreat);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DialogCollectRewardsDogTreat.tsx
// module id = 2815
// module chunks = 3